module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/pc/fv_1ad00432f24a447c457d1cb147f89be9.jpg";